const isTokenAvailable = () => {
  let token = localStorage.getItem("token");
  if (!token) {
    return false;
  }
  return token;
};

export default isTokenAvailable;
